import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table } from 'react-bootstrap';
// import '../css/table.css';
import '../css/main.css';

export default class MaintenanceAuditAppendComponent extends React.Component {

	previousPage() {
		hashHistory.push("/auditing");
	}

	componentWillMount() {
		this.props.findAuditableMCards(this.props.request.get('target'));
	}

	appendMissingDamageDetail(card) {
		//MaintenanceAppendModifyComponent
		this.props.assignAppendTarget(card);
		hashHistory.push("/auditingAppendModify");
	}

	render() {

        let cardStatus = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return '可部分檢點';

                case 'FIXED':
                    return '可檢點';

                case 'AUDITED':
                    return '檢點完成';

                default:
                    return "";
            }
        }

        let highlight = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFE8BF",
                    };
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",
                    };
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",
                    };
                default:
                    return {};
            }
        }

        let highlightClassName = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return "highlight-brown";
                case 'FIXED':
                    return "highlight-red";
                case 'AUDITED':
                    return "highlight-green";
                default:
                    return '';
            }
        }

        let sortIcon = (field) => {
            let orders = this.props.request.get('sortOrders');
            let asc = orders.get(field).get('asc');
            let icon;
            if (asc === undefined || orders.get('orderby') !== field) {
                icon = 'sort.svg';
            } else {
                icon = asc ? 'sort-up.svg' : 'sort-dw.svg';
            }

            return <a
                onClick={(event) => {
                    this.props.sortCards(
                        this.props.response.get('cards'),
                        this.props.request.get('sortOrders').get(field));
                }
                }>
                <img src={icon} height="18" width="18" className='sort' alt="" />
            </a>
        }

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		return (
			<div>
				<h4>
					檢點作業&nbsp;&gt;&gt;&nbsp;增補項目&nbsp;
						<a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<span hidden> MaintenanceAuditAppendComponent </span>
				<table className="main">
					<tbody>
						<tr>
							<th width="14%">訂單編號</th>
							<td width="22%" className={"highlight"} style={{ textAlign: "center" }}>{this.props.request.get("mcase").orderId} {this.props.request.get("mcase").note}</td>
							<th width="14%">客戶名稱</th>
							<td width="22%">{this.props.request.get("mcase").customer.customerName}</td>
							<th width="14%">建立時間</th>
							<td width="14%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
						</tr>
					</tbody>
				</table>
				<br />

				<Table striped bordered condensed hover>
					<thead>
						<tr>
							<th>序號 {sortIcon("code")}</th>
							<th>單位 {sortIcon("unit")}</th>
							<th>使用者 {sortIcon("owner")}</th>
							<th>建立時間</th>
							<th>狀態 {sortIcon("status")}</th>
							<th>增補項目 {sortIcon("status")}</th>
						</tr>
					</thead>
					<tbody>
						{
							this.props.response.get('cards').map(
								(item, index) =>
									<tr key={index}>
										<td>{item.code}</td>
										<td>{item.organization}{item.unit}</td>
										<td>{item.owner}</td>
										<td>{new Date(item.createTime).toLocaleDateString()}</td>
										<td style={highlight(item.status)} className={highlightClassName(item.status)}>{cardStatus(item.status)}</td>
										<td style={alignCenter}>
											<Button bsStyle="warning"
												onClick={(event) => {
													this.appendMissingDamageDetail(item);
												}}
											>增補項目...</Button>
										</td>
									</tr>
							)
						}
					</tbody>
				</Table>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceAuditAppendComponent.jsx